import React from 'react';
import { Typography } from '@mui/material';

const NoActiveSubscriptionAlert = ({ isFromPartner, partnerEmail }) => (
  <div style={{ textAlign: 'left', flex: 1 }}>
    <Typography variant="body1" sx={{ fontSize: '1.2rem', fontWeight: 'bold', textAlign: 'center', mr: '5rem' }}>
      {isFromPartner
        ? `No active subscription. Please reach out to ${partnerEmail}.`
        : 'No active subscription. Please reach out to support@marmin.ai.'}
    </Typography>
  </div>
);

export default NoActiveSubscriptionAlert;
